import axios from 'axios';
import { TEST_SERVER_URL } from '../constants/Common';
//import { getUserDetails } from '../actions/Auth';

export default axios.create({
    baseURL: `http://${TEST_SERVER_URL}:3004/`,//YOUR_API_URL HERE
    headers: {
        'accept': 'application/json',
        'content-type': 'application/json'
        //'Authorization': sessionStorage.getItem('user') ? 'Bearer '+getUserDetails().TOKEN : null
    }
});
